import store from '@/store';

export const setBreadcrumb = (breadcrumb) => {
	return store.dispatch('breadcrumb/setBreadcrumb', breadcrumb, { root: true });
}

export const mergeBreadcrumb = (breadcrumb) => {
	return store.dispatch('breadcrumb/mergeBreadcrumb', breadcrumb, { root: true });
}



// WEBPACK FOOTER //
// ./src/helpers/breadcrumb-helper.js